export default __webpack_public_path__ + "static/media/linkedin.73fde850.svg";